"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notification = void 0;
const ModelCommon_1 = require("../ModelCommon");
const typeName = 'Notification';
class Notification extends ModelCommon_1.ModelCommon {
    // pk either user or self
    // dpk === NotificationSubscription
    // dsk === Incident or other grouping hash
    constructor({ ...ob }) {
        super(typeName, ob);
        this.name = `${ob.messageTitle}`;
        this.ttl = ob.ttl;
        this.incidentSk = ob.incidentSk;
        this.MessageId = ob.MessageId;
        this.messageTitle = ob.messageTitle;
        this.messageContent = ob.messageContent;
        this.messageHTML = ob.messageHTML;
        this.deliveryType = ob.deliveryType;
        this.emailDestinations = ob.emailDestinations;
        this.smsDestinations = ob.smsDestinations;
        this.timestamp = ob.timestamp;
        this.success = ob.success;
        this.acknowledged = ob.acknowledged;
    }
    acknowledgeNotification() {
        this.acknowledged = true;
    }
}
exports.Notification = Notification;
